import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

// pembayaran
import Pembayaran from '@/components/User/Pembayaran/index'
import PembayaranMain from '@/components/User/Pembayaran/main'

// ovo
import RincianBayar from '@/components/User/Rincian-Bayar/index'
import RincianBayarMain from '@/components/User/Rincian-Bayar/main'

// success
import success from '@/components/User/success/index'
import successMain from '@/components/User/success/main'
import successVAMain from '@/components/User/success/main-va'
import successRetailMain from '@/components/User/success/main-retail'
import successTripayRetailMain from '@/components/User/success/main-tripay-retail'
import successEwalletMain from '@/components/User/success/main-ewallet'
// Beranda
import Beranda from '@/components/User/Beranda/index'
import BerandaMain from '@/components/User/Beranda/main'

// Bantuan
import Bantuan from '@/components/User/Bantuan/index'
import BantuanMain from '@/components/User/Bantuan/main'

// History
import History from '@/components/User/History/index'
import HistoryMain from '@/components/User/History/main'
import HistoryDetail from '@/components/User/History/detail'

// Akun
import Akun from '@/components/User/Akun/index'
import AkunMain from '@/components/User/Akun/main'
// Akun > Pengaduan
import Pengaduan from '@/components/User/Akun/Pengaduan/index'
import PengaduanMain from '@/components/User/Akun/Pengaduan/main'
import PengaduanDetail from '@/components/User/Akun/Pengaduan/detail'

// PENGUMUMAN
import Pengumuman from '@/components/User/Pengumuman/index'
import PengumumanMain from '@/components/User/Pengumuman/main'
import PengumumanDetail from '@/components/User/Pengumuman/detail'

// GANTI PEMBYARAN
import Ganti from '@/components/User/Ganti/index'
import GantiMain from '@/components/User/Ganti/main'

// GANTI PEMBYARAN
import Login from '@/components/User/Login/index'
import LoginMain from '@/components/User/Login/main'
import LoginNoMain from '@/components/User/Login/main-no'

// BAYAR NO LOGIN
import NoLoginDetail from '@/components/User/NoLogin/Detail/index'
import NoLoginDetailMain from '@/components/User/NoLogin/Detail/main'

// PROSES BAYAR
import Wallet from '@/components/User/Wallet/index'
import WalletMain from '@/components/User/Wallet/main'

// ISOLIR
import Isolir from '@/components/User/Isolir/index'
import IsolirMain from '@/components/User/Isolir/main'

// MODEMku
import Modem from '@/components/User/Modem/index'
import ModemMain from '@/components/User/Modem/main'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/beranda',
      name: '',
      component: Beranda,
      children: [
        {
          path: '',
          name: 'beranda',
            component: BerandaMain
        }
      ]
    },
    {
      path: '/bantuan',
      name: '',
      component: Bantuan,
      children: [
        {
          path: '',
          name: 'bantuan',
            component: BantuanMain
        }
      ]
    },
    {
      path: '/history',
      name: '',
      component: History,
      children: [
        {
          path: '',
          name: 'history',
            component: HistoryMain
        },
        {
          path: 'detail',
          name: 'history-detail',
            component: HistoryDetail
        }
      ]
    },
    {
      path: '/akun',
      name: '',
      component: Akun,
      children: [
        {
          path: '',
          name: 'akun',
            component: AkunMain
        }
      ]
    },
    {
      path: '/pengaduan',
      name: '',
      component: Pengaduan,
      children: [
        {
          path: '',
          name: 'pengaduan',
            component: PengaduanMain
        },
        {
          path: 'detail',
          name: 'pengaduan-detail',
            component: PengaduanDetail
        }
      ]
    },
    {
      path: '/pembayaran',
      name: '',
      component: Pembayaran,
      children: [
        {
          path: '',
          name: 'pembayaran',
            component: PembayaranMain
        }
      ]
    },
    {
      path: '/detail',
      name: '',
      component: RincianBayar,
      children: [
        {
          path: '',
          name: 'detail',
            component: RincianBayarMain
        }
      ]
    },
    {
      path: '/success',
      name: '',
      component: success,
      children: [
        {
          path: '',
          name: 'success',
            component: successMain
        }
      ]
    },
    {
      path: '/success-va',
      name: '',
      component: success,
      children: [
        {
          path: '',
          name: 'success-va',
            component: successVAMain
        }
      ]
    },
    {
      path: '/success-retail',
      name: '',
      component: success,
      children: [
        {
          path: '',
          name: 'success-retail',
            component: successRetailMain
        }
      ]
    },
    {
      path: '/success-tripay-retail',
      name: '',
      component: success,
      children: [
        {
          path: '',
          name: 'success-tripay-retail',
            component: successTripayRetailMain
        }
      ]
    },
    {
      path: '/pengumuman',
      name: '',
      component: Pengumuman,
      children: [
        {
          path: '',
          name: 'pengumuman',
            component: PengumumanMain
        },
        {
          path: 'detail',
          name: 'pengumuman-detail',
            component: PengumumanDetail
        }
      ]
    },
    {
      path: '/ganti-metode',
      name: '',
      component: Ganti,
      children: [
        {
          path: '',
          name: 'ganti-metode',
            component: GantiMain
        }
      ]
    },
    {
      path: '/login',
      name: '',
      component: Login,
      children: [
        {
          path: '',
          name: 'login',
            component: LoginMain
        }
      ]
    },
    {
      path: '/nologin',
      name: '',
      component: Login,
      children: [
        {
          path: '',
          name: 'nologin',
            component: LoginNoMain
        }
      ]
    },
    {
      path: '/inv/:uid',
      name: '',
      component: NoLoginDetail,
      children: [
        {
          path: '',
          name: 'nl-detail',
            component: NoLoginDetailMain
        }
      ]
    },
    {
      path: '/proses-bayar',
      name: '',
      component: Wallet,
      children: [
        {
          path: '',
          name: 'proses-bayar',
            component: WalletMain
        }
      ]
    },
    {
      path: '/success-ewallet',
      name: '',
      component: success,
      children: [
        {
          path: '',
          name: 'success-ewallet',
            component: successEwalletMain
        }
      ]
    },
    {
      path: '/isolir/:ow',
      name: '',
      component: Isolir,
      children: [
        {
          path: '',
          name: 'isolir',
            component: IsolirMain
        }
      ]
    },
    {
      path: '/modem/',
      name: '',
      component: Modem,
      children: [
        {
          path: '',
          name: 'modem',
            component: ModemMain
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js